<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show" class="py-0">
                    <v-toolbar class="py-0 my-0" dark color="green">
                        <v-toolbar-title class="my-0 py-0">Listado situación actual - Bienes</v-toolbar-title>

                    </v-toolbar>
                </v-card>
                <v-card color="green lighten-4" class="py-0 my-0">
                    <v-card-text>
                        <v-data-table dense :headers="headers" :items="listadoequipo" locale="es-ar" class="elevation-1"
                            :items-per-page="400" hide-default-footer>
                        </v-data-table>
                    </v-card-text>
                </v-card>


            </v-form>
        </v-app>
    </div>
</template>

<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
export default {
    data: (vm) => ({
        valid: false,
        deshabilitar: false,
        lazy: false,
        fecha: moment().format("DD/MM/YYYY"),
        listadoequipo: [],
        datos: [],
        headers: [
            { text: "Código", value: "codgral", width: "10%", sortable: false },
            { text: "Bien", value: "detalle", width: "50%", sortable: false },
            { text: "Situación Actual", value: "actual", width: "20%", sortable: false },
            { text: "Unidad", value: "tipo", width: "20%", sortable: false },
            { text: "Fecha", value: "fecha", width: "20%", sortable: false },
        ],

    }),
    computed: {

        show: {
            get() {
                this.cargarEquipo();
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        vaciarModels() {
            this.listadoequipo = []
        },
        cargarEquipo() {
            let self = this;
            axios
                .get("/SSGG/CargarEquiposCarga?", {
                    params: {
                    },
                })
                .then((response) => {
                    self.listadoequipo = response.data;
                })
                .catch((error) => {
                    self.listadoequipo = "";
                    console.log(error);
                });
        },

    }
};
</script>